import classnames from 'classnames';

import { Button } from '@/core/tamagoshi/Button/Button';
import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { HeartBorder } from '@/domains/core/tamagoshi/icons/HeartBorder';
import { HeartFull } from '@/domains/core/tamagoshi/icons/HeartFull';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { GTM_EVENTS_DATA } from '@/domains/proB2BServices/AddToWishlist/gtmEvents';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';

import { useUnloggedWishlistButton } from '../../hooks/useUnloggedWishlistButton';
import { addToWishlistLabel } from '../../translations';

import styles from '../../fragments.module.scss';

interface Props {
  onClick: () => void;
  isWishlistRevampEnabled: boolean;
  isProductInWishlistNow: boolean;
  isFetching: boolean;
  productId: number;
}

export const AddToWishlistButton = ({
  onClick,
  isWishlistRevampEnabled,
  isProductInWishlistNow,
  isFetching,
  productId,
}: Props) => {
  const [isPDPRevampEnabled] = useBooleanFlags([
    StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP,
  ]);

  const { isGuestOrAnon, handleUnloggedClick } = useUnloggedWishlistButton(
    onClick,
    productId,
  );

  const clickButton = () => {
    if (isFetching) return;
    onClick();
    Gtm.push({
      ...GTM_EVENTS_DATA.ADD_TO_WISHLIST,
      event_trigger: 'Click on heart PDP',
    });
  };

  return (
    <Button
      onClick={isGuestOrAnon ? handleUnloggedClick : clickButton}
      className={classnames({
        [styles.pdpRevamp]: isPDPRevampEnabled,
        [styles.animateFavIconOnPage]:
          isWishlistRevampEnabled && isProductInWishlistNow,
        [styles.showWaiting]: isWishlistRevampEnabled && isFetching,
      })}
      icon={
        <span className={styles.hearts}>
          <HeartBorder className={styles.heartBorder} />
          <HeartFull
            className={
              isWishlistRevampEnabled ? styles.heartBlack : styles.heart
            }
          />
          <HeartFull className={styles.heart1} />
          <HeartFull className={styles.heart2} />
          <HeartFull className={styles.heart3} />
        </span>
      }
      variant="secondary"
      data-testid="addToWishlist"
      aria-label={addToWishlistLabel}
      disabled={isFetching}
    />
  );
};
